<template>
    <div
        class="sidebar-item"
        :class="'sidebar-item--'+item.id"
        v-on="$listeners"
        @mouseover="startHover"
        @mouseleave="endHover"
        ref="sidebarItem"
    >
        <UserIcon v-if="item.id == 'profile'" class="sidebar-item__profile" :currentUser="true" />
        <div v-else-if="item.iconName" class="sidebar-item-icon">
            <SvgIcon class="sidebar-item-icon__icon" :name="item.iconName" />             
        </div>

        <div class="sidebar-item__text">{{item.name}}</div>

        <div v-if="item.dot" class="sidebar-item__dot"/>
    </div>
</template>

<script>
import SvgIcon from '../global/SvgIcon.vue';
import UserIcon from '../UserIcon.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'SidebarItem',
    components: { SvgIcon, UserIcon },
    props: {
        item: Object
    },
    data: function() {
        return {
        }
    },
    computed: {
        ... mapGetters({
            'isMobile': 'viewport/isMobile'
        }),
        shouldShowTooltip() {
            return this.item.isDisabled && this.item.disabledMessage
        },
        tooltipPosition() {
            const elementPosition = this.$refs.sidebarItem.getBoundingClientRect()

            if (!this.isMobile) {
                return {
                    x: elementPosition.right - 5,
                    y: elementPosition.top + (elementPosition.height / 2),
                    centerY: true
                }
            } else {
                return {
                    x: elementPosition.left + (elementPosition.width / 2),
                    y: elementPosition.top - 30,
                    centerX: true
                }
            }
        }
    },
    methods: {
        ... mapActions({
            setTooltip: 'tooltip/setTooltip',
            clearTooltip: 'tooltip/clearTooltip'
        }),
        startHover() {
            if (this.shouldShowTooltip) {
                this.setTooltip({
                    ... this.tooltipPosition,
                    text: this.item.disabledMessage
                })
            }
        },
        endHover() {
            this.clearTooltip()
        },
    }
}
</script>

<style lang="scss" scoped>
@import "~@/scss/components/sidebar/sidebaritem.scss";
</style>
